import { toLower } from 'lodash';
import React from 'react'
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../../store/actions';
class Crietaria extends Component{  
   componentDidMount(){
       this.props.onFetchContries();       
   }
   render(){       
       let country = this.props.contries.find(contary => toLower(contary.name) === this.props.contary);             
       return(
        <div className="col-lg-4">
            <div className="criteria-content pt-5">
                <h4 className="heading4 text-color1 text-center">Criteria for {country ? country.name : null}</h4>                 
                <div className="text-center ">
                     {country ? country.hasOwnProperty("programs") ? 
                      <div className="criteria-list mt-5">  
                      <ul className="list-unstyled mb-0">                        
                        <li>
                            <span className="criteria-data">
                                 <span className="count">1.</span>
                                 <span className="text">{country ? country.programs[0] !== undefined ? country.programs[0].min_ielts > 0 ? `${country.programs[0].min_ielts} Bands required for Undergraduate`:"Bands are not required for Undergraduate" : "Does not offer Diploma" : null }</span>
                                 <span className="text">{country ? country.programs[0] !== undefined ? country.programs[0].min_marks > 0 ? `${country.programs[0].min_marks}% Marks required for Undergraduate`:"Marks are not required for Undergraduate" : "Does not offer Diploma" : null }</span>
                            </span>
                         </li>
                        <li>
                            <span className="criteria-data">
                                 <span className="count">2.</span>
                                 <span className="text">{country ? country.programs[1] !== undefined ? country.programs[1].min_ielts > 0 ? `${country.programs[1].min_ielts} Bands required for Masters`:"Bands are not required for Masters" : "Does not offer Diploma" : null }</span>
                                 <span className="text">{country ? country.programs[1] !== undefined ? country.programs[1].min_marks > 0 ? `${country.programs[1].min_marks}% Marks required for Masters`:"Marks are not required for Masters" : "Does not offer Diploma" : null }</span>
                            </span>
                         </li>
                        <li>
                            <span className="criteria-data">
                                 <span className="count">3.</span>
                                 <span className="text">{country ? country.programs[2] !== undefined ? country.programs[2].min_ielts > 0 ? `${country.programs[2].min_ielts} Bands required for diploma`:"Bands are not required for diploma" : "Does not offer Diploma" : null }</span>
                                 <span className="text">{country ? country.programs[2] !== undefined ? country.programs[2].min_marks > 0 ? `${country.programs[2].min_marks}% Marks required for diploma`:"Marks are not required for diploma" : "Does not offer Diploma" : null }</span>
                            </span>
                         </li>
                    </ul>
                    </div>
                     :  
                     <div className="text-center">There are no programmes</div> : null}
                </div>
            </div>
        </div>
      )
   }
}

const mapStateToProps = state =>{
    return{
        contries : state.contries
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
      onFetchContries: () => dispatch(actions.fetchContries())
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Crietaria));